// extracted by css-extract-rspack-plugin
export default {"root":"root-PIjJmf","compact":"compact-cR6kWG"};